var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"image"},[_c('legend',{staticClass:"has-background-white",staticStyle:{"padding":"0.25rem"}},[_vm._v(_vm._s(_vm.$t('Page'))+" "+_vm._s(_vm.number))]),_c('img',{ref:"image",style:(_vm.styles),attrs:{"src":_vm.source,"alt":_vm.label},on:{"load":_vm.load}})])
}
var staticRenderFns = []

export { render, staticRenderFns }